/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

/** Utilities */
import { mapDropdownOptions } from "../../../components/finalForms/libs/mapDropdownOptions";

/** Common Components */
import Buttons from "../../../components/ui/button/Buttons";
import CardSection from "../../../components/ui/card/CardSection";
import FormCreator from "../../../components/finalForms/FormCreator";

/** Common Services & Data Files */
import { decryptUrlData } from "../../../services/CryptoService";
import ToastService from "../../../services/toastService/ToastService";

/** Configuration Files */
import { userFormData } from "./config/User.data";

/** RTK Query */
import {
  useAddUserMutation,
  useLazyGetAllUserTLAndAdminQuery,
  useLazyGetCheckUserQuery,
  useLazyGetUserByIdQuery,
  useUpdateUserMutation,
} from "../../../app/services/userAPI";
import {
  useResendEmailUserPasswordMutation,
  useUserTempResetPasswordMutation,
} from "../../../app/services/ResetPasswordAPI";
import { useLazyGetRoleListQuery } from "../../../app/services/RoleManagement";
import { useLazyGetAllOrganizationLocationQuery } from "../../../app/services/organizationAPI";

/** Lazily Loaded Component */
import AddUserPassword from "./AddUserPassword/AddUserPassword";

const AddEditUser = (props) => {
  const userRef = useRef();

  const { id } = useParams();
  const userId = id ? decryptUrlData(id) : null;

  const navigate = useNavigate();
  const organizationId = useSelector((state) => state.auth.user.organizationId);

  /* State*/
  const [userForm, setUserForm] = useState(userFormData);
  const [isResetPassword, setIsResetPassword] = useState(false);

  // API'S Call
  const [addUser, {
    isSuccess: isUserAdded,
    isLoading: isUserAdding,
    data: addUserData
  },] = useAddUserMutation();

  const [getAllRoles, {
    isFetching: isRoleFetching,
    isSuccess: isRoleSuccess,
    data: RoleData
  },] = useLazyGetRoleListQuery();


  const [getAllUserTLAndAdmin, {
    isFetching: isUserTLAndAdminFetching,
    isSuccess: isUserTLAndAdminSuccess,
    data: UserTLAndAdminData
  },] = useLazyGetAllUserTLAndAdminQuery();

  const [getCheckUser,
  ] = useLazyGetCheckUserQuery();

  const [getAllOrganizationLocation, {
    isFetching: isOrgFetching,
    isSuccess: isOrgFetched,
    data: OrgData
  },] = useLazyGetAllOrganizationLocationQuery();

  const [getUserById, {
    isLoading: isGetByIdLoading,
    isFetching: isGetByIdFetching,
    isSuccess: isGetByIdSuccess,
    data: isGetByIdData,
  },] = useLazyGetUserByIdQuery();

  const [updateUser, {
    isLoading: isUserUpdating,
    isSuccess: isUserUpdated,
    data: UserUpdateData,
  },] = useUpdateUserMutation();

  const [resendPass, {
    isLoading: isResendDataLoading,
    isSuccess: isResendDataSucess,
    data: resendPassData
  }] = useResendEmailUserPasswordMutation()

  const [resetPass, {
    isLoading: isResetLoading,
    isSuccess: isDataSucess,
    data: isresetPassData
  }] = useUserTempResetPasswordMutation()


  const resetform = () => {
    const form = { ...userFormData }
    form.initialState = { ...userFormData.initialState }
    setUserForm(form);
  };

  const backtoList = () => {
    resetform();
    navigate("/admin/users");
  };

  useEffect(() => {

    getAllOrganizationLocation();
    getAllUserTLAndAdmin();
    getAllRoles();
    if (userId) {
      getUserById(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (!isOrgFetching && isOrgFetched && OrgData) {

      mapDropdownOptions(userFormData, 'useDetails', 'locationId', OrgData, 'locationId', 'addressLine1',);

    }
  }, [isOrgFetched, isOrgFetching, OrgData]);

  useEffect(() => {
    if (!isRoleFetching && isRoleSuccess && RoleData) {

      mapDropdownOptions(userFormData, 'useDetails', 'roleId', RoleData, 'roleId', 'roleName',);
    }
  }, [isRoleFetching, isRoleSuccess, RoleData]);

  useEffect(() => {
    if (!isUserTLAndAdminFetching && isUserTLAndAdminSuccess && UserTLAndAdminData) {

      mapDropdownOptions(userFormData, 'useDetails', 'repotingManager', UserTLAndAdminData, 'userId', 'userName',);

    }
  }, [isUserTLAndAdminSuccess, isUserTLAndAdminFetching, UserTLAndAdminData]);

  useEffect(() => {

    if (isGetByIdSuccess && !isGetByIdFetching && isGetByIdData) {
      setIsResetPassword(isGetByIdData.isResetPassword);
      const updatedUserForm = {
        ...userFormData,
        initialState: {
          ...userFormData.initialState,
          repotingManager: isGetByIdData.reportingManager,
          roleId: isGetByIdData.roleId,
          organizationId: organizationId,
          profilePic: `data:image/png;base64,${isGetByIdData.profilePicBase64}`,
          base64File: isGetByIdData.profilePicBase64,
          firstName: isGetByIdData.firstName,
          lastName: isGetByIdData.lastName,
          phone: isGetByIdData.phone,
          storagepath: isGetByIdData.profilePic,
          emailAddress: isGetByIdData.emailAddress,
          userName: isGetByIdData.userName,
          gender: isGetByIdData.gender,
          isActive: isGetByIdData.isActive,
          isSupperAdmin: isGetByIdData.isSupperAdmin,
          isTwoFactorAuth: isGetByIdData.isTwoFactorAuth,
          locationId: isGetByIdData.addressLineId,
          isResetPassword: isGetByIdData.isResetPassword,
          isTimesheetRequired: isGetByIdData.isTimesheetRequired
        },
        section: userFormData.section.map((sectionItem) => {
          return {
            ...sectionItem,
            fields: sectionItem.fields.map((field) => {
              if (field.id === "userName" || field.id === "emailAddress") {
                return {
                  ...field,
                  fieldSetting: {
                    ...field.fieldSetting,
                    isDisable: true,
                  },
                };
              }
              return field;
            }),
          };
        }),
      };
      setUserForm(updatedUserForm);
    }
  }, [isGetByIdSuccess, isGetByIdFetching, isGetByIdData]);

  useEffect(() => {

    if (isUserAdded && addUserData) {
      if (addUserData.errorMessage.includes("exists")) {
        ToastService.warning(addUserData.errorMessage);
        return;
      } else {
        ToastService.success(addUserData.errorMessage);
        backtoList();
      }
    }
  }, [isUserAdded, addUserData]);


  useEffect(() => {

    if (isUserUpdated && UserUpdateData) {
      if (UserUpdateData.errorMessage.includes("exists")) {
        ToastService.warning(UserUpdateData.errorMessage);
        return;
      } else {
        ToastService.success(UserUpdateData.errorMessage);
        backtoList();
      }
    }
  }, [isUserUpdated, UserUpdateData]);

  useEffect(() => {

    if (isDataSucess && isresetPassData) {
      if (isresetPassData?.errorMessage === "") {
        ToastService.success("Password Reset");
      }
      else {
        ToastService.error(isresetPassData?.errorMessage);
      }
    }
  }, [isDataSucess, isresetPassData]);

  useEffect(() => {

    if (isResendDataSucess && resendPassData) {
      if (resendPassData?.errorMessage === "") {
        ToastService.success("Password resend");
      }
      else {
        ToastService.error(resendPassData?.errorMessage);
      }
    }
  }, [isResendDataSucess, resendPassData]);

  const handleSubmit = async () => {

    let userData = userRef.current.getFormData();
    let isImageUpdated = Array.isArray(userData.profilePic);

    if (!userId && userData) {
      const requestData = {
        ...userData,
        repotingManager: userData.repotingManager.value,
        roleId: userData.roleId && typeof userData.roleId === 'object' ? userData.roleId.value : userData.roleId,
        organizationId: organizationId,
        profilePic: userData.profilePic?.[0]?.fileName,
        base64File: userData.profilePic?.[0]?.base64Data,
        addressLineId: userData.locationId.value,
        isTwoFactorAuth: userData.isTwoFactorAuth,
        isTimesheetRequired: userData.isTimesheetRequired
      };

      const result = await getCheckUser(userData.userName);

      if (result.data.errorMessage === "User already Exist") {
        ToastService.warning("Username already exists.");
      } else {
        addUser(requestData);
      }

    } else if (userId && userData) {

      let requestDataUpdate = {

        userId: userId,
        organizationId: organizationId,
        profilePic: isImageUpdated
          ? userData.profilePic[0]?.fileName
          : userData.storagepath,
        base64File: isImageUpdated
          ? userData.profilePic[0]?.base64Data
          : userData.base64File,
        firstName: userData.firstName,
        lastName: userData.lastName,
        phone: userData.phone,
        emailAddress: userData.emailAddress,
        userName: userData.userName,
        gender: userData.gender,
        isActive: userData.isActive,
        isSupperAdmin: userData.isSupperAdmin,
        isTwoFactorAuth: userData.isTwoFactorAuth,
        isTimesheetRequired: userData.isTimesheetRequired,
        addressLineId: userData.locationId && typeof userData.locationId === 'object' ? userData.locationId.value : userData.locationId,
        roleId: userData.roleId && typeof userData.roleId === 'object' ? userData.roleId.value : userData.roleId,
        repotingManager: userData.repotingManager && typeof userData.repotingManager === 'object' ? userData.repotingManager.value : userData.repotingManager,

      };
      
      updateUser(requestDataUpdate);

    }
  };


  const handleResendpass = () => {
    if (userId) {
      let request = {
        userId: userId,
      };
      resendPass(request);
    }
  }

  const handleResetpass = () => {
    if (userId) {
      let request = {
        userId: userId,
      };
      resetPass(request);
    }
  }


  return (
    <div className="main-page-scroll add-edit-userpage">
      <div className="center-top-space">
        <CardSection
          isContentLoading={isGetByIdLoading}
          cardTitle="User Information"
        >
          <div className="row">
            <FormCreator
              key={false}
              ref={userRef}
              config={userForm}
            />

          </div>
          <div className="d-flex justify-content-end mt-2 right-align">
            {userId && (
              isResetPassword ? (
                <Buttons
                  buttonTypeClassName="theme-btn  mr-4"
                  onClick={() => handleResendpass()}
                  isLoading={isResendDataLoading}
                  buttonText="Resend Password"
                />
              ) : (
                <Buttons
                  buttonTypeClassName="theme-btn  mr-4"
                  onClick={() => handleResetpass()}
                  isLoading={isResetLoading}
                  buttonText="Reset Password"
                />
              ))}

            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={backtoList}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn  ml-4"
              buttonText={`${userId ? "Update" : "Add"}`}
              onClick={handleSubmit}
              isLoading={isUserAdding || isUserUpdating}
            />
          </div>
        </CardSection>
        {userId && !isResetPassword && (
          <div className="mt-4 change-password">
            <CardSection
              iconVector="mdi:password-outline"
              cardTitle={"Change Password"}
            >
              <AddUserPassword userData={userId} />
            </CardSection>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddEditUser;
